// extracted by mini-css-extract-plugin
module.exports = {"card":"category_cards_card__ORTBj","image-wrapper":"category_cards_image-wrapper__W0P2x","text":"category_cards_text__bPFW5"};